<template>
  <div v-if="visible" class="igreja-ad-wrap">
    <div class="igreja-ad" role="complementary" aria-label="Anúncio do desenvolvedor">
      <span class="ad-label">Anúncio</span>
      <button class="ad-close" type="button" @click="dismiss" aria-label="Dispensar">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
      </button>

      <div class="ad-brand">
        <img src="/juliodevelop-logo.png" alt="JulioDevelop" class="ad-logo" />
        <span class="ad-brand-name">JulioDevelop</span>
      </div>

      <p class="ad-headline">{{ variant.headline }}</p>
      <p class="ad-sub">{{ variant.subtitle }}</p>

      <a class="ad-cta" :href="ctaLink" target="_blank" rel="noopener" @click="trackClick">
        <span>{{ variant.cta }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/></svg>
      </a>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = 'jd_igreja_ad_dismissed_at'
const COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000
const DELAY_MS = 8000
const TARGET_URL = 'https://juliodevelop.online/criar-site-institucional-para-igreja?utm_source=acamp-elshaday&utm_medium=ad&utm_campaign=igreja'

const VARIANTS = [
  {
    headline: 'Sua igreja merece tecnologia profissional.',
    subtitle: 'Esse sistema foi feito sob medida pra El Shaday. Posso construir o da sua igreja também.',
    cta: 'Saiba mais'
  },
  {
    headline: 'Site, app, inscrições, gestão de ofertas.',
    subtitle: 'Igrejas que organizam o digital chegam mais longe.',
    cta: 'Conhecer agora'
  },
  {
    headline: 'Acampamento, secretaria, eventos.',
    subtitle: 'Sistemas sob medida pra igrejas e ministérios que querem crescer.',
    cta: 'Ver soluções'
  },
  {
    headline: 'Curtiu esse sistema de inscrição?',
    subtitle: 'Posso fazer o de qualquer evento da sua igreja — culto, retiro, conferência.',
    cta: 'Quero um igual'
  }
]

function pickVariant() {
  return VARIANTS[Math.floor(Math.random() * VARIANTS.length)]
}

export default {
  name: 'IgrejaAd',
  data() {
    return {
      visible: false,
      variant: VARIANTS[0]
    }
  },
  computed: {
    ctaLink() { return TARGET_URL }
  },
  mounted() {
    this.variant = pickVariant()
    try {
      const last = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10)
      if (Date.now() - last < COOLDOWN_MS) return
    } catch (e) { /* sem localStorage, exibe mesmo */ }
    this.timer = setTimeout(() => { this.visible = true }, DELAY_MS)
  },
  beforeUnmount() {
    if (this.timer) clearTimeout(this.timer)
  },
  methods: {
    dismiss() {
      this.visible = false
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())) } catch (e) { /* noop */ }
    },
    trackClick() {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())) } catch (e) { /* noop */ }
    }
  }
}
</script>

<style scoped>
.igreja-ad-wrap {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin: 16px 0 8px;
}

.igreja-ad {
  position: relative;
  width: 100%;
  max-width: 520px;
  background: linear-gradient(135deg, #0f3a23 0%, #1a472a 50%, #226a40 100%);
  color: #fff;
  padding: 28px 18px 18px;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 58, 35, 0.25), 0 2px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  animation: slideUp 0.4s ease;
  overflow: hidden;
}
.igreja-ad::before {
  content: '';
  position: absolute;
  top: -40%;
  right: -10%;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(34, 197, 94, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ad-label {
  position: absolute;
  top: 8px;
  left: 12px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
}

.ad-close {
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-fast);
}
.ad-close:hover { background: rgba(255, 255, 255, 0.22); color: #fff; }

.ad-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.ad-logo {
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 6px;
  padding: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.ad-brand-name {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  opacity: 0.92;
}

.ad-headline {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.25;
  word-break: break-word;
}
.ad-sub {
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.45;
  opacity: 0.85;
  word-break: break-word;
}

.ad-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #0f3a23;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  transition: var(--transition-fast);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.ad-cta:hover { background: #f0fff5; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12); }
.ad-cta svg { transition: transform 0.2s; }
.ad-cta:hover svg { transform: translateX(2px); }

/* Pequenos ajustes pra telas estreitas */
@media (max-width: 380px) {
  .igreja-ad { padding: 26px 14px 16px; border-radius: 12px; }
  .ad-headline { font-size: 14px; }
  .ad-sub { font-size: 12px; }
  .ad-cta { padding: 9px 14px; font-size: 12px; width: 100%; justify-content: center; }
}
</style>
